import React from "react";
import { useTranslation } from "react-i18next";
import { FAQItem } from "../molecules/FAQItem";

export const FAQSection: React.FC = () => {
  const { t } = useTranslation();

  const faqs = [
    {
      question: t("landing.faq.q1.question"),
      answer: t("landing.faq.q1.answer"),
    },
    {
      question: t("landing.faq.q2.question"),
      answer: t("landing.faq.q2.answer"),
    },
    {
      question: t("landing.faq.q3.question"),
      answer: t("landing.faq.q3.answer"),
    },
    {
      question: t("landing.faq.q4.question"),
      answer: t("landing.faq.q4.answer"),
    },
    {
      question: t("landing.faq.q5.question"),
      answer: t("landing.faq.q5.answer"),
    },
    {
      question: t("landing.faq.q6.question"),
      answer: t("landing.faq.q6.answer"),
    },
    {
      question: t("landing.faq.q7.question"),
      answer: t("landing.faq.q7.answer"),
    },
  ];

  return (
    <section id="faq" className="py-12 md:py-20 bg-[#f1ede7]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-juridico mb-4">
            {t("landing.faq.title")}
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="max-w-7xl mx-auto">
          {faqs.map((faq, index) => (
            <FAQItem key={index} index={index} {...faq} />
          ))}
        </div>
      </div>
    </section>
  );
};
